import { BaseModel } from 'src/app/core/_base/crud';
import {
  NotificationScope,
  NotificationSource,
  NotificationTarget,
  NotificationTrigger,
} from '../enums/notification.enum';

export interface NotificationCategory {
  id: number;
  name: string;
  company_id: number;
}

export interface NotificationChannel {
  id: number;
  name: string;
}
export interface NotificationCriteria {
  id: number;
  name: string;
}
export interface NotificationCriteriaSettings {
  id: number;
  notificationCriteriaId: number;
  notificationId: number;
}
export class Notification extends BaseModel {
  id: number;
  description: string;
  source: NotificationSource;
  scope: NotificationScope;
  trigger: NotificationTrigger;
  name: string;
  template: string;
  template_es: string;
  target: NotificationTarget;
  category: NotificationCategory;
  channels: NotificationChannel[];
  is_active: boolean;
  language: string;

  constructor(
    id = 0,
    description = '',
    source?,
    scope?,
    target?,
    category?,
    channels?,
    name?,
    template?,
    template_es?,
    trigger?,
    is_active = true,
  ) {
    super();
    this.id = id;
    this.description = description;
    this.source = source;
    this.scope = scope;
    this.target = target;
    this.category = category;
    this.channels = channels;
    this.name = name;
    this.template = template;
    this.template_es = template_es;
    this.trigger = trigger;
    this.is_active = is_active;
  }
}
